


import { Component, Vue } from "vue-property-decorator";

import { CustomError, Password } from "@Internal/Models";

import { Account } from "App";
import { $t } from "App/IOC";

import Ocean from "Web/Components/Common/Ocean.vue";
import PasswordChecklist from "Web/Components/Common/PasswordChecklist.vue";

@Component({
    components: {
        Ocean,
        PasswordChecklist
    }
})
export default class ActivateView extends Vue {
    private firstName: string = "";

    private password: string = "";
    private confirmation: string = "";

    private passwordFocused: boolean = false;

    private loading: boolean = true;
    private invalid: boolean = false;
    private done: boolean = false;
    private busy: boolean = false;

    private error: string = "";

    private get token(): string {
        return String( this.$route.params.token );
    }

    private get passwordValid(): boolean {
        return !( new Password( this.password ).Validate() instanceof CustomError );
    }

    private get canSubmit(): boolean {
        return this.passwordValid && this.password === this.confirmation;
    }

    private async created(): Promise<void> {
        const [ invitation, error ] = await Account.GetInvitation( this.token );

        this.loading = false;

        if( error !== undefined || invitation === undefined || invitation.Email === "" ) {
            this.invalid = true;
            return;
        }

        this.firstName = invitation.FirstName;
    }

    private check(): void {
        if( this.confirmation !== "" && this.password !== this.confirmation )
            this.error = $t( "ACTIVATE_mismatch" );
        else
            this.error = "";
    }

    private async submit(): Promise<void> {
        if( this.busy || !this.canSubmit )
            return;

        this.busy = true;

        const error = await Account.Activate( this.token, new Password( this.password ) );

        this.busy = false;

        if( error !== undefined ) {
            this.error = error.Message;
            return;
        }

        this.done = true;
    }
}
